import { render, staticRenderFns } from "./CreateData.vue?vue&type=template&id=8cf4e5ce&scoped=true"
import script from "./CreateData.vue?vue&type=script&lang=js"
export * from "./CreateData.vue?vue&type=script&lang=js"
import style0 from "./CreateData.vue?vue&type=style&index=0&id=8cf4e5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf4e5ce",
  null
  
)

export default component.exports